import { lazy } from 'react';

// Define importers separately so we can lazy render and optionally preload
const iconImporters = {
  coffee: () => import('./icons/coffee.svg'),
  sunrise: () => import('./icons/sunrise.svg'),
  'egg-fried': () => import('./icons/egg-fried.svg'),
  'bed-double': () => import('./icons/bed-double.svg'),
  pancakes: () => import('./icons/pancakes.svg'),
  sailboat: () => import('./icons/sailboat.svg'),
  lighthouse: () => import('./icons/lighthouse.svg'),
  kayak: () => import('./icons/kayak.svg'),
  lei: () => import('./icons/lei.svg'),
  taco: () => import('./icons/taco.svg'),
  bedtime: () => import('./icons/bedtime.svg'),
  'fine-dining': () => import('./icons/fine-dining.svg'),
  golf: () => import('./icons/golf.svg'),
  'poke-bowl': () => import('./icons/poke-bowl.svg'),
  wine: () => import('./icons/wine.svg'),
  stargazing: () => import('./icons/stargazing.svg'),
  surfer: () => import('./icons/surfer.svg'),
  musubi: () => import('./icons/musubi.svg'),
  flower: () => import('./icons/flower.svg'),
  burger: () => import('./icons/burger.svg'),
  waterfall: () => import('./icons/waterfall.svg'),
  'swinging-bridge': () => import('./icons/swinging-bridge.svg'),
  camera: () => import('./icons/camera.svg'),
  'hiking-boot': () => import('./icons/hiking-boot.svg'),
  'shave-ice': () => import('./icons/shave-ice.svg'),
  movie: () => import('./icons/movie.svg'),
  'hot-tub': () => import('./icons/hot-tub.svg'),
  'cinnamon-roll': () => import('./icons/cinnamon-roll.svg'),
  beach: () => import('./icons/beach.svg'),
  compass: () => import('./icons/compass.svg'),
  'simple-compass': () => import('./icons/simple-compass.svg'),
  clipboard: () => import('./icons/clipboard.svg'),
  interview: () => import('./icons/interview.svg'),
  brain: () => import('./icons/brain.svg'),
  calendar: () => import('./icons/calendar.svg'),
  refresh: () => import('./icons/refresh.svg'),
};

const lazySvg = (importFn) =>
  lazy(() =>
    importFn().then((module) => ({
      default: module.ReactComponent,
    }))
  );

export const iconMap = Object.fromEntries(
  Object.entries(iconImporters).map(([name, importer]) => [name, lazySvg(importer)])
);

// Expose importers so callers can preload icons as needed (e.g., before rendering carousels)
export const iconPreloadMap = iconImporters;
